import * as C from "@/components";
import {VimeoBackground} from "@/components/Video/VimeoBackground";

const imageDirectory = "/images/products/cartridges/active-snaptix-mouthpiece/";

export const SnaptixNewReleaseCard = () => {
    return (
        <a className='relative p-3 w-full h-full md:w-auto'>
            <C.Card link='/snaptix-mouthpiece' className='relative w-full md:w-[348px] h-[417px] duration-300 hover:scale-[1.01]'>
                <div className="absolute z-[23] w-full text-center text-[#414042] p-5 mt-2.5">
                    <p className='font-semibold text-xl lg:text-2xl mb-5'>
                        Snaptix Mouthpiece</p>
                    <p>
                        Keeps out lint, dust,<br/>and everything else.</p>
                </div>
                <VimeoBackground
                    link={'/snaptix-mouthpiece'}
                    videoId={1089130922}
                    className='top-1/2'
                    unlistedPrivacyHash={'d291bf0de9'}
                    isVideoUnlisted
                    imageDirectory={imageDirectory}
                    needsThumbnail
                    thumbnailName='snaptix-new-release-thumbnail.jpg'
                />
            </C.Card>
        </a>
    );
}
